module.exports = __webpack_public_path__ + "img/trash.644ff6cf.svg";